const divCalendarActionCard = {
  verification: 'Verificação',
  equipment: 'Equipamento',
  place: 'Local',
  company: 'Empresa',
  accountable: 'Responsáveis',
  noAccountable: 'Sem Responsáveis',
  service: 'Serviço',
  serviceAction: 'Ação Criada por'
};

export default divCalendarActionCard;
